module.exports = __webpack_public_path__ + "static/media/avatar-18.0194742d.svg";